import { TViewerQuery } from 'gql'
import { createContext } from 'react'

interface Paypal {
  clientId: string
  codonationMerchantId: string
  env: string
}

interface Stripe {
  key: string
}

interface FriendlyCaptcha {
  puzzleEndpoint: string
  sitekey: string
}

interface Posthog {
  apiKey: string
  apiHost: string
}

export interface AppProps {
  hostname: string
  paymentLiveMode: string
  paypal: Paypal
  stripe: Stripe
  friendlyCaptcha: FriendlyCaptcha
  posthog: Posthog
}

export type ViewerContextType = {
  viewer?: TViewerQuery['viewer']
  viewerLoading?: boolean
}
export type AppContextType = { appConfigLoading: true } | (AppProps & { appConfigLoading: false })
export const AppContext = createContext<AppContextType>({ appConfigLoading: true })
export const ViewerContext = createContext<ViewerContextType>({} as ViewerContextType)
